import { put, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  roundCanceledAction,
  changeGameStateAction,
  changeGameStatusAction,
  addToastAction,
  startDrawFailureAction,
  changeTimeLeftAction,
  setHasUndefinedCardToStore,
  clearCardsToStoreAction,
  setNextCardPositionToStore,
  cancelLastCardUsedAction,
} from 'data/reducers';
import { Notifications, RoundCanceledResponse, TableStates, ToastTypes } from 'types';
import { gameStatus, alerts } from 'constants/common';
import { IState } from 'core/types';
import { getGameData } from 'core/selectors';
import { GameType } from 'types/tables';

export function* roundCanceled({ type: notificationType, data: result }: RoundCanceledResponse) {
  try {
    if (notificationType === Notifications.ROUND_CANCELED) {
      const { game_type } = yield select(getGameData);
      const startDrawLoading = yield select((state: IState) => state.loading.START_DRAW);
      if (startDrawLoading) {
        yield put(startDrawFailureAction());
      }
      yield put(changeGameStateAction({ tableState: TableStates.RoundCanceled }));
      yield put(changeTimeLeftAction({ timerLeft: undefined }));
      yield put(changeGameStatusAction({ status: gameStatus.OpenRound }));
      yield put(roundCanceledAction());
      if (result.fromAdmin) {
        yield put(addToastAction({ type: ToastTypes.WARNING, value: alerts.ROUND_CANCELED }));
      }

      if (game_type === GameType.CLASSIC_BAC) {
        yield put(clearCardsToStoreAction());
        yield put(setHasUndefinedCardToStore(false));
        yield put(setNextCardPositionToStore(null));
        yield put(cancelLastCardUsedAction(false));
      }
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
